import React, { ComponentType, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface ProtectedRoutesProps {
  Component: ComponentType<any>;
  [key: string]: any; // Allow any additional props
}

const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({
  Component,
  ...rest
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      const currentPath = location.pathname;
      if (currentPath.startsWith("/forms/preview")) {
        navigate("/login?returnUrl=" + currentPath);
      } else {
        navigate("/login");
      }
    }
  }, [localStorage.getItem("accessToken"), navigate]);

  return <Component {...rest} />;
};

export default ProtectedRoutes;
